import React from "react";
import Grid from "@mui/material/Grid";
import BackButton from "../BackButton";
import Alert from "@mui/material/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function ScreenAlert(props) {
  const { severity, message, fontSize } = props;
  const severityIconEnum = {
    error: <ErrorIcon sx={{ fontSize }} />,
    succes: <CheckCircleIcon sx={{ fontSize }} />,
  };
  return (
    <>
      <BackButton />
      <Grid
        container
        direction={"row"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
        sx={{ minHeight: "100vh" }}
      >
        <Grid item>
          <Alert
            icon={severityIconEnum[severity]}
            sx={{
              fontSize: fontSize,
              display: "flex",
              alignItems: "center",
              boxShadow: "0 8px 40px -12px rgba(0,0,0,0.5)",
            }}
            severity={severity}
          >
            {message}
          </Alert>
        </Grid>
      </Grid>
    </>
  );
}

export default ScreenAlert;
